import React from 'react';
import PropTypes from 'prop-types';

type ErrorState = {
  hasError: boolean;
  error: any;
  errorInfo: any;
};

class ErrorBoundary extends React.Component<any, ErrorState> {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  };

  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  async componentDidCatch(error: any, errorInfo: any) {
    // TODO: Action in Datadog
  }

  render() {
    const { error, errorInfo, hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      const safeError = error && error.toString();
      return (
        <div style={{ color: 'red', overflowY: 'auto' }}>
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {safeError}
            <br />
            {errorInfo.componentStack}
          </details>
          <br />
        </div>
      );
    }

    return <>{children}</>;
  }
}

export default ErrorBoundary;
